module.exports = __webpack_public_path__ + "img/ky-wx.37e127f1.png";